/** @ngInject */
export default function NewUserController($state, $timeout, userService, UserModel, NotificationService, UtilService, environmentService) {
  var availableRolesCopy,
    vm = this;

  vm.isLoading = false;
  vm.newUser = new UserModel();
  vm.userForm = {};
  vm.createUser = createUser;
  vm.getAvailableUserRoles = getAvailableUserRoles;
  vm.toggleUserRole = toggleUserRole;
  vm.isNotReadyToBeSaved = isNotReadyToBeSaved;
  vm.allowSetPassword = false;

  init();

  function init() {
    vm.allowSetPassword = !environmentService.isBetaOrProduction();
    getAvailableUserRoles();
  }

  function isNotReadyToBeSaved() {
    return (vm.allowSetPassword && vm.newUser.password.length < 5) || !vm.newUser.roles.length || vm.userForm.$invalid;
  }

  function createUser() {
    if (vm.isLoading) {
      return;
    }

    userService
      .createUser(vm.newUser)
      .then(function() {
        handleSaveUser();
      })
      .catch(function(res) {
        var message = 'Error creating user';
        if (res.data && res.data.errors) {
          message = res.data.errors[0].message;
        }
        NotificationService.error(message);
      })
      .finally(function() {
        vm.loading = false;
      });
  }

  function getAvailableUserRoles() {
    userService.getAvailableUserRoles().then(function(res) {
      vm.availableRoles = res.data;
      availableRolesCopy = vm.availableRoles;
    });
  }

  function toggleUserRole(role) {
    UtilService.toggleElementFromArray(vm.newUser.roles, role);
  }

  function handleSaveUser() {
    emptyForm();
    $state.go('app.users', {}, { reload: true });
    NotificationService.success('The user was successfully created.');
  }

  function emptyForm() {
    vm.newUser = new UserModel();
    vm.userForm.$setPristine();
    vm.availableRoles = [];

    $timeout(function hackToWaitForNgRepeatToUpdateItsModel() {
      vm.availableRoles = availableRolesCopy;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/users/new-user.controller.js